import CoreRouteGenerator from '@nordvpn/teams.core/lib/atoms/RouteGenerator';
import { PrivateRoute } from 'routing/PrivateRoute';
export var RouteGenerator = function RouteGenerator(routes) {
    return CoreRouteGenerator(routes, PrivateRoute);
};
